/* Caipi Redesign — Marken-Landingpage: FAQ-Accordion + „Mehr Artikel" inline nachladen. */
(function () {
  'use strict';

  function initFaq(root) {
    var wrap = root.querySelector('[data-rd-brand-faq]');
    if (!wrap || wrap.dataset.rdInit === '1') return;
    wrap.dataset.rdInit = '1';
    wrap.addEventListener('click', function (e) {
      var btn = e.target.closest('.rd-brand__faq-q');
      if (!btn) return;
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      var ans = btn.parentNode.querySelector('.rd-brand__faq-a');
      if (ans) { if (open) { ans.setAttribute('hidden', ''); } else { ans.removeAttribute('hidden'); } }
    });
  }

  /* „Mehr Artikel von {Marke} anzeigen": die nächste Produktseite per fetch holen und
     die Karten INLINE ans Grid hängen — kein Reload, kein Sprung nach oben. Der Button
     bleibt ein echter Link (?page=N) als No-JS-Fallback. */
  function initMore(root) {
    if (root.dataset.rdMoreInit === '1') return;
    root.dataset.rdMoreInit = '1';
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-rd-brand-more]');
      if (!btn) return;
      e.preventDefault();
      if (btn.getAttribute('aria-busy') === 'true') return;
      var url = btn.getAttribute('href');
      var grid = root.querySelector('.rd-brand__grid');
      if (!url || !grid) return;
      var label = btn.textContent;
      btn.setAttribute('aria-busy', 'true');
      btn.textContent = 'Lädt …';
      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (!html) throw new Error('fetch');
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('.rd-brand__grid');
          if (newGrid) {
            while (newGrid.firstElementChild) { grid.appendChild(newGrid.firstElementChild); }
          }
          var nextBtn = doc.querySelector('[data-rd-brand-more]');
          if (nextBtn && nextBtn.getAttribute('href')) {
            btn.setAttribute('href', nextBtn.getAttribute('href'));
            btn.textContent = label;
            btn.removeAttribute('aria-busy');
          } else if (btn.parentNode) {
            btn.parentNode.removeChild(btn); // letzte Seite erreicht
          }
        })
        .catch(function () { btn.textContent = label; btn.removeAttribute('aria-busy'); });
    });
  }

  function boot() {
    document.querySelectorAll('.rd-brand').forEach(function (r) { initFaq(r); initMore(r); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
